import { createFileRoute } from '@tanstack/react-router';
import { PersonalSettingsRoute } from './-route-wrappers';

// Index route only. The `/settings/personal/security` screens have their own route files.
export const Route = createFileRoute('/_authenticated/settings/personal/')({
  component: PersonalSettingsRoute,
});
